import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Users } from 'lucide-react';

interface BulkUpgradeSummaryCardsProps {
  totalSubscriptions: number;
  processingFeeSavings: number;
  formatCurrency: (amount: number) => string;
}

export const BulkUpgradeSummaryCards: React.FC<BulkUpgradeSummaryCardsProps> = ({
  totalSubscriptions,
  processingFeeSavings,
  formatCurrency
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Card className="border border-gray-200 dark:border-gray-700">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Total Subscriptions</CardTitle>
          <Users className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{totalSubscriptions}</div>
          <p className="text-xs text-muted-foreground">
            Selected for update
          </p>
        </CardContent>
      </Card>

      <Card className="border border-gray-200 dark:border-gray-700">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Potential Savings</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-green-600">
            +{formatCurrency(processingFeeSavings)}
          </div>
          <p className="text-xs text-muted-foreground">
            Estimated monthly savings
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

